import {
  Grid2X2,
  List,
  Search,
} from "lucide-react";

function MenuToolbar({
  search,
  category,
  active,
  ordering,
  viewMode,
  categories,
  onSearchChange,
  onCategoryChange,
  onActiveChange,
  onOrderingChange,
  onViewModeChange,
}) {
  return (
    <section className="admin-menu-toolbar">
      <div className="admin-menu-toolbar__search">
        <Search size={18} />

        <input
          type="search"
          value={search}
          onChange={(event) =>
            onSearchChange(event.target.value)
          }
          placeholder="Search menu items..."
        />
      </div>

      <div className="admin-menu-toolbar__filters">
        <select
          value={category}
          onChange={(event) =>
            onCategoryChange(event.target.value)
          }
          aria-label="Filter by category"
        >
          <option value="">All categories</option>

          {categories.map((categoryOption) => (
            <option
              key={categoryOption.id}
              value={categoryOption.id}
            >
              {categoryOption.name}
            </option>
          ))}
        </select>

        <select
          value={active}
          onChange={(event) =>
            onActiveChange(event.target.value)
          }
          aria-label="Filter by visibility"
        >
          <option value="">All visibility</option>
          <option value="true">Visible</option>
          <option value="false">Hidden</option>
        </select>

        <select
          value={ordering}
          onChange={(event) =>
            onOrderingChange(event.target.value)
          }
          aria-label="Sort menu items"
        >
          <option value="display_order">
            Display order
          </option>
          <option value="name">Name A–Z</option>
          <option value="-name">Name Z–A</option>
          <option value="price">Price: low to high</option>
          <option value="-price">Price: high to low</option>
          <option value="-created_at">Newest first</option>
        </select>

        <div className="admin-view-toggle">
          <button
            type="button"
            className={
              viewMode === "grid"
                ? "admin-view-toggle__active"
                : ""
            }
            aria-label="Grid view"
            onClick={() => onViewModeChange("grid")}
          >
            <Grid2X2 size={18} />
          </button>

          <button
            type="button"
            className={
              viewMode === "list"
                ? "admin-view-toggle__active"
                : ""
            }
            aria-label="List view"
            onClick={() => onViewModeChange("list")}
          >
            <List size={19} />
          </button>
        </div>
      </div>
    </section>
  );
}

export default MenuToolbar;